import * as requests from "@/API/requests";

const otherCalculators = {
  namespaced: true,
  state: () => ({}),
  mutations: {},
  actions: {
    async calculateCompoundInterest(store, { payload, options } = {}) {
      return await requests.compoundInterestCalculatorRequest(payload, options);
    },
    async calculatePmt(store, { payload, options } = {}) {
      return await requests.calculatePmtRequest(payload, options);
    },
  },
  getters: {},
};

export default otherCalculators;
